import React from 'react';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';
import { change } from 'redux-form';

import withRollingArrangements from 'decorators/withRollingArrangements';
import Pagination from 'components/Pagination/Pagination';
import RollingArrangementList from 'components/RollingArrangementList/RollingArrangementList';
import { getIncludedInGroups } from 'reducers';
import RollingArrangementsFilters from 'components/RollingArrangementsFilters';
import Spinner from 'components/Spinner';

class RollingArrangements extends React.Component {
  handleApplyFilters = (values) => {
    const { history } = this.props;
    let query = { page: 1 };
    Object.entries(values).forEach(([key, value]) => {
      if (value) {
        query[key] = value;
      }
    });
    history.push({
      pathname: '/rolling-arrangements',
      search: qs.stringify(query),
    });
  };

  handleResetFilters = () => {
    const keys = ['user_profile', 'arrangement_day', 'enabled'];
    let isChanged = false;
    keys.forEach((key) => {
      if (this.props[key]) {
        isChanged = true;
      }
      this.props.changeField('rollingArrangementsFilters', key, '');
    });
    if (isChanged) {
      this.handleApplyFilters(
        keys.reduce((acc, key) => {
          acc[key] = undefined;
          return acc;
        }, {}),
      );
    }
  };

  getNextPage = (nextPage) => {
    const { user_profile, arrangement_day, enabled } = this.props;

    let params = { user_profile, arrangement_day, enabled, page: nextPage };
    params = Object.entries(params).reduce((acc, [key, value]) => {
      if (typeof value !== 'undefined') {
        acc[key] = value;
      }
      return acc;
    }, {});

    const search = new URLSearchParams(params).toString();

    return `/rolling-arrangements?${search}`;
  };

  render() {
    const {
      rollingArrangements,
      isAdminOrManagerOrBillingOrAgentOrReadOnlyAdmin,
      user_profile,
      arrangement_day,
      enabled,
      pageCount,
      page,
      loading,
    } = this.props;

    const filtersInitialValues = {
      user_profile,
      arrangement_day,
      enabled,
    };

    if (!isAdminOrManagerOrBillingOrAgentOrReadOnlyAdmin) {
      return <Redirect to={'/'} />;
    }

    return (
      <div>
        <h1>Rolling Arrangements</h1>
        <RollingArrangementsFilters
          onSubmit={this.handleApplyFilters}
          onResetFilters={this.handleResetFilters}
          initialValues={filtersInitialValues}
        />
        <RollingArrangementList rollingArrangements={rollingArrangements} />
        <Pagination count={pageCount} current={page} url={this.getNextPage} />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAdminOrManagerOrBillingOrAgentOrReadOnlyAdmin: getIncludedInGroups(state, [
    'ADMIN',
    'MANAGER',
    'BILLING',
    'AGENT',
    'READ_ONLY_ADMIN',
  ]),
});

const mapDispatchToProps = {
  changeField: change,
};

export default compose(
  withRollingArrangements,
  connect(mapStateToProps, mapDispatchToProps),
)(RollingArrangements);
